// Port of api/fuel/app/classes/filter/package/lists.php
// JS note:
// - this file wires the Lists package type into the offline entity pipeline
// - it should stay aligned with PHP Filter\\Package\\Lists, with JS-only work limited to runtime orchestration
import Listing from 'offline/model/listing'
import ListingEntity from 'offline/filter/package/lists/listing'

export default {
	run: function(config, filter, data, global) {
		var resultIds = data.results || []
		var rows = {}
		var results = []
		var listRows
		var i

		if (resultIds.length) {
			listRows = Listing.where([
				['list_id', 'in', resultIds]
			])

			for (i = 0; i < listRows.length; i++) {
				rows[listRows[i].get_id()] = listRows[i]
			}
		}

		global.results = rows
		global.resultIndex = resultIds
		global = ListingEntity.run_data(global, config, filter, data)

		for (i = 0; i < resultIds.length; i++) {
			var result = ListingEntity.run(resultIds[i], { id: resultIds[i] }, global, config, filter)
			if (result) results.push(result)
		}

		return [results, { nested: {} }]
	}
}
